import { Collapse } from "antd"
import React from "react"
import cx from "classnames"
import { isAldeia } from "hooks/useAldeia"
import { cn } from "lib/utils"

interface CollapseCardsProps {
  panels: {
    key: string
    title: string | React.ReactNode
    content: React.ReactNode
    forceRender?: boolean
    className?: string
  }[]
  defaultActiveKey?: string[]
  activeKey?: string[]
  onChange?: ((key: string | string[]) => void) | undefined
  transparent?: boolean
  destroyInactivePanel?: boolean
  bordered?: boolean
  shadow?: boolean
  animated?: boolean
  className?: string
}

function CollapseCards(props: CollapseCardsProps) {
  return (
    <Collapse
      // accordion
      defaultActiveKey={props.defaultActiveKey}
      {...(props.activeKey && { activeKey: props.activeKey })}
      onChange={props.onChange}
      ghost
      destroyInactivePanel={props.destroyInactivePanel}
      expandIconPosition="end"
      expandIcon={(panelProps) => (
        <span className="!-mr-2">
          <i
            className={`fas fa-${panelProps.isActive ? "chevron-down" : "chevron-right"}`}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 28,
              height: 28,
              fontSize: 13,
            }}
          />
        </span>
      )}
      style={{
        border: "none",
      }}
      className={cx(
        props.transparent ? "" : "g_collapse_cards",
        props.bordered && "g_collapse_cards_bordered",
        props.shadow && "[&_.ant-collapse-item]:shadow",
        props.className,
      )}
    >
      {props.panels?.map((panel, i) => (
        <Collapse.Panel
          forceRender={panel.forceRender}
          header={
            <div
              style={{
                marginTop: isAldeia ? 0 : -4,
              }}
            >
              {panel?.title}
            </div>
          }
          key={panel?.key}
          className={cn(props.animated ? "animate-fade-up animate-duration-200" : "", panel.className)}
          style={{
            animationDelay: `${0.1 * (i + 1)}s`,
          }}
        >
          {panel?.content}
        </Collapse.Panel>
      ))}
    </Collapse>
  )
}

export default CollapseCards
